import styled from 'styled-components';
import HR from 'UIComponents/elements/HR';
import AsyncUIAvatar from '../components/AsyncUIAvatar';
// @ts-expect-error Not a TS file
import ResponderOption from '../components/ResponderOption';
import { getAgentId, getAgentState, getAvatarUrl, getBotId, getEmail, getFirstName, getIsAssignable, getLastName } from '../operators/assignees';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrentUserHR = styled(HR).withConfig({
  displayName: "UserOptionHD__CurrentUserHR",
  componentId: "sc-4ttem-0"
})(["margin-bottom:10px;margin-top:0;"]);
const UserOptionHD = ({
  currentAssigneeId,
  currentUserId,
  option,
  isUngatedForWorkingHours
}) => {
  if (!option || !option.responder) {
    return null;
  }
  const {
    responder
  } = option;
  const user = /*#__PURE__*/_jsx(ResponderOption, {
    agentId: getAgentId(responder) || getBotId(responder),
    agentState: getAgentState(responder),
    AsyncUIAvatar: AsyncUIAvatar,
    avatar: getAvatarUrl(responder),
    currentAssigneeId: currentAssigneeId,
    email: getEmail(responder),
    firstName: getFirstName(responder),
    isAssignable: getIsAssignable(responder),
    lastName: getLastName(responder),
    responder: responder,
    isUngatedForWorkingHours: isUngatedForWorkingHours
  });
  if (currentUserId === option.value) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "p-left-1",
        children: user
      }), /*#__PURE__*/_jsx(CurrentUserHR, {})]
    });
  }
  return user;
};
UserOptionHD.displayName = 'UserOptionHD';
export default UserOptionHD;